module.exports = __webpack_public_path__ + "static/icons/icon-holidays-073576edfa7062484b957b6f50282499.svg";